export interface UserSetting {
  rememberSearchFilters: boolean;
  firstName: string;
  lastName: string;
  mlsAccessSettings?: MlsAccessSetting[] | null;
  roles: UserRole[] | null;
  enabledCharts?: string[] | null;
  id: string;
  userName: string;
}

export interface UserSettingApiResponse extends Omit<UserSetting, 'roles'> {
  roles?: { id: number; role: UserRole; companyKey: string; userId: number }[] | null;
}

export interface MlsAccessSetting {
  membershipNumber: string;
  verified?: boolean | null;
  state: string;
  SLNO: number;
  mlsAbbreviation: string;
  mlsBoard: string;
}

export enum UserRole {
  APPRAISER = 'APPRAISER',
  AMC_MANAGER = 'AMC_MANAGER',
  MANAGER = 'MANAGER',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  APP_ADMIN = 'APP_ADMIN',
  BROKER = 'BROKER',
  CHIEF_APPRAISER = 'CHIEF_APPRAISER',
  SUPERVISORY_APPRAISER = 'SUPERVISORY_APPRAISER',
  REVIEWER = 'REVIEWER',
  INSPECTOR = 'INSPECTOR',
  APPRAISAL_ASSISTANT = 'APPRAISAL_ASSISTANT',
}
